module.exports = __webpack_public_path__ + "img/EBIKE_CUP_LOGO_SCHRIFT.4bc5353a.svg";